// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { LogoutMessage } from '../Messages/LogoutMessage';
export class LogoutMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        return [new LogoutMessage(fieldSet)];
    }
}
